import axios from "@/axios"; 

const API_URL = process.env.VUE_APP_API_BASE_URL;

export default {
    async getPortStatusCheck(olt_ip,olt_port,Mikrotik_ip,m_port) {
  
      try {
        const response = await axios.get(API_URL+`/api/check-ports-4/?olt_ip=${olt_ip}&olt_port=${olt_port}&mk_ip=${Mikrotik_ip}&mk_port=${m_port}`);
        return response.data;
      } catch (error) {
        console.error("Error retrieving user:", error);
        throw error; 
      }
    },

    
  };
